import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/logo.png?v=1",
  alt: "logo",
  style: {"height":"80px"}
}, null, -1)
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _ctx.locale }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout, { style: {"min-height":"100vh"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: { background: 'none', height: 'inherit', padding: 0, } }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu, {
                mode: "horizontal",
                "active-key": (_ctx.$route.name as string),
                theme: "dark",
                style: { justifyContent: 'center', alignItems: 'center' },
                "selected-keys": []
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { key: "logo" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.RouteName.TOP }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { key: "home" }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: _ctx.getHomeUrl()
                      }, _toDisplayString(_ctx.$t('text.home')), 9, _hoisted_2)
                    ]),
                    _: 1
                  }),
                  (_ctx.isLoggedIn)
                    ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: 0 }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_UserOutlined)
                        ]),
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.authUser.name), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_menu_item, { onClick: _ctx.onLogout }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_LogoutOutlined)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.logout')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: _ctx.RouteName.LOGIN
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: { name: _ctx.RouteName.LOGIN }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('text.login')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _: 1
                        })),
                        (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: _ctx.RouteName.REGISTER
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: { name: _ctx.RouteName.REGISTER }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('text.register')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _: 1
                        }))
                      ], 64))
                ]),
                _: 1
              }, 8, ["active-key"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { class: "mt-20" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale"]))
}